import { render, staticRenderFns } from "./FSIDriverMaster.vue?vue&type=template&id=504c4dd5&scoped=true"
import script from "./FSIDriverMaster.vue?vue&type=script&lang=js"
export * from "./FSIDriverMaster.vue?vue&type=script&lang=js"
import style0 from "./FSIDriverMaster.vue?vue&type=style&index=0&id=504c4dd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504c4dd5",
  null
  
)

export default component.exports